Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var coreComponentsShared = require('../../shared');

var measureVisualViewport = function (visualViewport) {
    if (!visualViewport)
        return null;
    var height = visualViewport.height, offsetTop = visualViewport.offsetTop;
    return { height: height, offsetTop: offsetTop };
};
function useVisibleViewportSize(enabled) {
    if (enabled === void 0) { enabled = false; }
    var _a = React.useState(function () {
        return coreComponentsShared.isClient() ? measureVisualViewport(window.visualViewport) : null;
    }), size = _a[0], setSize = _a[1];
    React.useEffect(function () {
        var visualViewport = window.visualViewport;
        if (!coreComponentsShared.isClient() || !enabled || !visualViewport)
            return coreComponentsShared.fnUtils.noop;
        var listener = function (event) {
            return setSize(measureVisualViewport(event.target));
        };
        visualViewport.addEventListener('resize', listener);
        visualViewport.addEventListener('scroll', listener);
        return function () {
            visualViewport.removeEventListener('resize', listener);
            visualViewport.removeEventListener('scroll', listener);
        };
    }, [enabled]);
    return size;
}

exports.useVisibleViewportSize = useVisibleViewportSize;
